export const CUSTOMER_FORM_STEP1 = 'What brings you here?';
export const CUSTOMER_FORM_STEP2 = 'Your details';
export const CUSTOMER_FORM_STEP3 = 'Tell us more';
export const CUSTOMER_FORM_FIN_STEP4 = 'Employment';
export const CUSTOMER_FORM_FIN_STEP5 = 'Income/Expenses';
export const CUSTOMER_FORM_LAST_STEP = 'Thank you';

export const ANALYTICS_NAMES = {
  LANDING: 'landing',
  YOUR_DETAILS: 'your-details',
  TELL_US_MORE: 'tell-us-more',
  EMPLOYMENT: 'employment',
  INCOME_EXPENSES: 'income-expenses',
  LAST_STEP: 'success',
};

export const AUSTRALIAN_STATE = ['NSW', 'QLD', 'ACT', 'VIC', 'WA', 'NT', 'TAS', 'SA'];
export type AuStateType = (typeof AUSTRALIAN_STATE)[number];
export const AUSTRALIA = 'Australia';
export const COMPLAINT = 'Complaint';
export const MIN_ADDRESS_SEARCH_STRING = 4;
export interface TextValueType {
  text: string;
  value: string;
}

export const YesNoList: TextValueType[] = [
  {
    text: 'Yes',
    value: 'yes',
  },
  {
    text: 'No',
    value: 'no',
  },
];

export const SOURCE_SYSTEM = 'CMS-SPA';
